/**
 * RF-G2 (verdict de review front, spec-010 `supervisor-e-agentes-de-dominio`)
 * — funções PURAS de acumulação dos agentes do turno (fan-out do
 * Supervisor). Extraídas de `apiChat.js` (perto do teto de linhas do repo —
 * mesmo precedente de `chat-event-handlers.js`, ver o cabeçalho dele) — sem
 * `store.dispatch` nenhum aqui: quem decide QUANDO despachar continua sendo
 * `apiChat.js`, este módulo só decide O QUE.
 *
 * Fecha a DIVERGÊNCIA DECLARADA de `chat-message.vue` (comentário acima de
 * `agenteDoTurno`): turno multi-agente agora acumula TODOS os agentes do
 * fan-out, não só o primeiro.
 */

/**
 * `agent-selected` chegou — entrada normalizada `{agentSlug, hub, motivo}`
 * pronta pra acumular. Assume que o chamador já garantiu `data.agent_slug`
 * (guard que `apiChat._onAgentSelected` faz antes de chamar).
 */
export function entradaDeAgentSelected(data) {
  return {
    agentSlug: data.agent_slug,
    hub: data.hub || null,
    motivo: data.motivo || '',
  }
}

/**
 * Acrescenta `entry` a `lista` — dedupe por `agentSlug` (reconfirmação do
 * mesmo agente não duplica nem reordena: o índice 0 nunca muda depois de
 * escrito, o que é o que faz um turno PINADO continuar vencendo um
 * `agent-selected` posterior, sem guarda própria pra isso).
 *
 * @returns {{lista: Array, mudou: boolean}} `lista` é a MESMA referência
 *   quando `mudou` é `false` — nada novo pra dispatchar ao vivo.
 */
export function acumularAgente(lista, entry) {
  const jaVisto = lista.some((agente) => agente.agentSlug === entry.agentSlug)
  if (jaVisto) return { lista, mudou: false }
  return { lista: lista.concat([entry]), mudou: true }
}

/**
 * `start` do turno — `_agentesDoTurno` inicial: `[entry]` quando PINADO
 * (`agent_slug` já no `start`, hub sabido antes do grafo rodar — um turno
 * pinado pode nunca emitir `agent-selected`), `[]` no roteamento normal
 * (chat humano, o agente chega depois).
 */
export function agentesIniciaisDoStart(data) {
  if (!data || !data.agent_slug) return []
  return [{ agentSlug: data.agent_slug, hub: data.hub || null, motivo: '' }]
}

/**
 * Payload de `setAgenteDaMensagem` a comitar no `end` do turno — `null`
 * quando não há o que comitar (turno sem agente resolvido, ou mensagem sem
 * `id` persistido: motor legado, ou o dual-emit não trouxe o campo).
 * `agentes` viaja o array COMPLETO do fan-out, não só o primeiro.
 */
export function payloadDeComitarAgente(newMsgId, agenteDoTurno, agentesDoTurno) {
  if (!agenteDoTurno || !newMsgId) return null
  return {
    id: newMsgId,
    ...agenteDoTurno,
    agentes: agentesDoTurno.slice(),
  }
}
